// carnet.component.ts
import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Base } from '../common/base';
import { MatDialog } from '@angular/material/dialog';
import dataDocuments from '../../../assets/data/documentsCarnet.json';
import { CarnetImgModel, CarnetModel, CarnetRespondeModel, JsonRespuestaCarnet } from '../../models/carnet';
import { NgxSpinnerService } from "ngx-spinner";
import { DialogCarnetSendComponent } from '../common/dialogs/dialog-carnet-send/dialog-carnet-send.component';
import { MaincontainerComponent } from '../maincontainer/maincontainer.component';
import { CarnetService } from '../../services/carnet/carnet.service';
import { UserLoggedResponse, UserRolResponde } from '../../models/user';
import { StorageService } from '../../utils/util.storage.service';
import { AuthService } from '../../services/security/auth.service';
import { jsPDF } from "jspdf";
import { TrackingService } from '../../services/app-track/tracking.service';
import { TrackData } from '../../models/app-track/track-data.model';
import { AutorizacionesService } from '../../services/mis-autorizaciones/misautorizaciones.service';
import { map, switchMap } from 'rxjs';

@Component({
  selector: 'app-carnet',
  templateUrl: './carnet.component.html',
  styleUrls: ['./carnet.component.css']
})
export class CarnetComponent extends Base {
  public frmCarnet: FormGroup = new FormGroup({});
  haveDate: boolean = false;
  carnedMessage: string = "";
  nombreColectivo: string = "";
  userCarnetData: CarnetModel = new CarnetModel();
  userImgData: CarnetImgModel = new CarnetImgModel();
  dsCarnet: CarnetRespondeModel[] = []; // Remplazar por data
  documentTypeData: any[] = dataDocuments as Array<any>;
  generalMessage: string = "";
  listSelectedCarnet: CarnetRespondeModel[] = [];
  jsonRespuesta!: JsonRespuestaCarnet;
  ownerData: any = { email: "correo@prueba.com", cellphone: "3178844444" };
  logInfo: any;
  cedulaAsesor: any;
  nombreAsesor: any;
  trackDataCarnet!: TrackData;

  constructor(
    private _formBuilder: FormBuilder,
    private matDialog: MatDialog,
    private spinner: NgxSpinnerService,
    private mainCmp: MaincontainerComponent,
    private carnetService: CarnetService,
    private storageService: StorageService,
    private trackingService: TrackingService,
    private authService: AuthService,
    private autorizacionService:AutorizacionesService
  ) {
    super();
    this.buildForm();
  }

  private buildForm(): void {
    this.frmCarnet = this._formBuilder.group({
      documentType: ['', [Validators.required]],
      documentNumber: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.mainCmp.setTitle("CARNÉ DE USUARIOS");
    });
  }

  async ngOnInit(): Promise<void> {
    this.logInfo = await this.authService.getAuthInfo();
    const userCC = this.logInfo?.document;
    this.cedulaAsesor = userCC.split('.')[1].trim();
    this.nombreAsesor = this.logInfo
          ? `${this.logInfo.nombre ?? ''} ${this.logInfo.primerApellido ?? ''} ${
              this.logInfo.segundoApellido ?? ''
            }`.trim()
          : 'N/A';  

    this.trackDataCarnet = {
      module: 'Carné de usuarios',
      category: 'N/A',
      submodule: 'Carné de usuarios',
      functionality: 'Consultar',
      cedulaAsesor: this.cedulaAsesor,
      fechaInteraccion: this.getCurrentTimestamp(),
      nombreAsesor: this.nombreAsesor,
      identificadorInteraccion: 'CARNE_USU_CONSULTAR'
    };
  };    

  consultCarnet() {
    if (this.frmCarnet.valid) {
      this.spinner.show();
      this.generalMessage = '';
      const userCC: UserLoggedResponse =
        this.storageService.getItem('user') ?? 'Document no esta llegando';
      const isExterno = userCC.roles[0].claveRol == 'Ova_AseExter';
      const role: UserRolResponde[] = userCC.roles;
      /*servicios*/
      this.userCarnetData = {
        typeDocument: this.frmCarnet.value.documentType,
        identification: this.frmCarnet.value.documentNumber,
        identificationAsesor: this.deleteSpaceAsesor(userCC.document),
        typeAsesor: role[0].claveRol,
      };
      const reqAsesor = {
        prm_docu_tipo: this.frmCarnet.value.documentType,
        prm_docu_nro: this.frmCarnet.value.documentNumber,
      };

      this.autorizacionService
        .getAsesorPoblacion(reqAsesor)
        .pipe(
          switchMap((resp) => {
            return this.carnetService
              .carnetData(this.userCarnetData)
              .pipe(map((response) => ({ resp, response })));
          }),
        )
        .subscribe({
          next: ({ resp, response }) => {
            this.jsonRespuesta = response;
            this.dsCarnet = [];
            console.log('data_carnet :', this.jsonRespuesta);
            console.log('data_asesor :', resp);
            if (resp != null && this.jsonRespuesta.data.length != 0) {
              if (!isExterno && resp.idAsesorPoblacion != '20') {
                this.haveDate = false;
                this.generalMessage = 'Este usuario pertenece a la población del canal externo.';
              } else if ((isExterno && resp.idAsesorPoblacion != '20') || (!isExterno && resp.idAsesorPoblacion == '20')) {
                this.haveDate = true;
                this.generalMessage = '';
                this.dsCarnet = this.jsonRespuesta.data;
              }else if(isExterno && resp.idAsesorPoblacion == '20'){
                this.haveDate = false;
                this.generalMessage = 'No se encontraron registros con el documento a consultar.';
              }
            } else {
              this.haveDate = false;
              this.generalMessage = 'No se encontraron registros con el documento a consultar.';
            }
            this.spinner.hide();
          },
          error: (error) => {
            this.spinner.hide();
            this.generalMessage = 'Error en obtener la data de los Carnet.';
          },
        });
    } else {
      this.generalMessage = 'Formulario incompleto.';
      this.haveDate = false;
    }
  }

  generateData(opc: number) { // 1 generar - 2 generar y enviar    
    const functionality = opc === 1 ? 'Generar' : 'Enviar al usuario';
    const identificadorInteraccion = opc === 1 
    ? 'CARNE_USU_GENERAR' 
    : 'CARNE_USU_ENVIAR';

    this.trackingService.trackEvent({
      module: 'Carné de usuarios',
      category: 'N/A',
      submodule: 'Carné de usuarios',
      functionality,
      cedulaAsesor: this.cedulaAsesor,
      fechaInteraccion: this.getCurrentTimestamp(),
      nombreAsesor: this.nombreAsesor,
      identificadorInteraccion
    }).subscribe({
      next: () => console.log(`Tracking registrado: ${functionality}`),
      error: () => console.warn('Error registrando tracking de generateData')
    });

    this.listSelectedCarnet = this.dsCarnet.filter(carnet => carnet.selected == true);
    if (this.listSelectedCarnet.length > 0) {
      this.generalMessage = "";
      if (opc == 1) {
        // this.showMessageDialog("Exito", "Se envio correctamente el/los carnet/s", "Aceptar", "", true, 1, this.matDialog, (_: any) => { });
        // this.generalMessage = "Se ha enviado con éxito.";
        this.listSelectedCarnet.forEach((item) => {
          this.consultImgCarnet(item, 'generate');
        });

      } else { // 2 
        this.listSelectedCarnet.forEach((item) => {
          this.consultImgCarnet(item, 'send')
        });
        const dialogRef = this.matDialog.open(DialogCarnetSendComponent, {
          disableClose: true,
          data: { option: opc, ownerData: this.ownerData, dataBeneficiaries: this.listSelectedCarnet, showPreview: false }
        });

        dialogRef.componentInstance.generateEvent.subscribe((selectedOption: number) => {
          this.generateData(selectedOption);
        });
      }
    } else {
      this.generalMessage = "No se ha seleccionado ningún carnet.";
    }
  }

  consultImgCarnet(listSelectedCarnet: CarnetRespondeModel, action: 'generate' | 'send' = 'generate') {
    this.spinner.show();
    this.userImgData = {
      planCarnet: listSelectedCarnet.Plan
    }
    this.carnetService.carnetImage(this.userImgData, action).subscribe({
      next: response => {
        this.jsonRespuesta = response;        
        if (this.jsonRespuesta.data && this.jsonRespuesta.data.length != 0) {          
          this.generatePDF(this.jsonRespuesta.data[0].Carnet, listSelectedCarnet)
        } else {
          this.generalMessage = this.jsonRespuesta.message + ' ' + listSelectedCarnet.Plan;
        }
        this.spinner.hide();
      },
      error: error => {
        this.spinner.hide();
        this.generalMessage = "Error en obtener la data de los Carnet.";
      }
    });
  }

  generatePDF(base64: string, listSelectedCarnet: CarnetRespondeModel): void {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const baseImage = new Image();
    baseImage.src = base64;
    baseImage.onload = () => {
      canvas.width = baseImage.width;
      canvas.height = baseImage.height;
      if (context) {
        //nombre del colectivo del servicio
        this.nombreColectivo = listSelectedCarnet.nombreColectivo;
        context.drawImage(baseImage, 0, 0);
        if (listSelectedCarnet.Plan == "ONCA") {
          context.font = '30px MainFontBold';
          context.fillStyle = 'black';
          context.fillText(listSelectedCarnet.AsesorGestion.toString(), 80, 400); //codigo asesor
          // Dibuja el texto de nombreColectivo con saltos de línea
          const lineHeight = 25; // Ajusta el alto de línea según sea necesario
          this.drawTextWithLineBreaks(context, this.insertLineBreaks(this.nombreColectivo, 48), 80, 425, lineHeight);
          context.fillText(listSelectedCarnet.nombre, 80, 490)
        } else {
          context.font = '35px MainFontBold';
          context.fillStyle = 'black';
          context.fillText(listSelectedCarnet.AsesorGestion.toString(), 80, 450); //codigo asesor
          context.fillText(listSelectedCarnet.nombre, 80, 480)
        }
        context.fillText(listSelectedCarnet.tipoPlan + " " + listSelectedCarnet.cobertura + " " + listSelectedCarnet.Plan + " " + listSelectedCarnet.franquicia, 180, 520); //plan
        context.fillText(listSelectedCarnet.identificacion.replace(/.*- /, ""), 800, 560); //identificación
        context.fillText(listSelectedCarnet.ContratoAfiliado + "  " + listSelectedCarnet.NumeroUsuario + "  " + listSelectedCarnet.numeroConsecutivo + "  " + listSelectedCarnet.Linea, 80, 560) //credencial
        context.fillText(listSelectedCarnet.FechaNacimiento.replace(/-/g, ''), 420, 625); //FECHA NACIMIENTO
        context.fillText(listSelectedCarnet.VigenciaPlan.replace(/-/g, ''), 780, 625); //FECHA inicio
        // Crear el PDF con el tamaño de la imagen
        const editedImage = canvas.toDataURL('image/jpeg');
        const pdfWidth = baseImage.width;
        const pdfHeight = baseImage.height;
        const doc = new jsPDF({
          orientation: pdfWidth > pdfHeight ? 'landscape' : 'portrait',
          unit: 'px',
          format: [pdfWidth, pdfHeight]
        });
        doc.addImage(editedImage, 'JPEG', 0, 0, pdfWidth, pdfHeight);
        doc.save('carnet' + '_' + listSelectedCarnet.nombre.trim().replace(/\s+/g, "_") + '_'+ listSelectedCarnet.identificacion.replace(/.*- /, "") + '_' + listSelectedCarnet.Plan + '.pdf');


        // TODO: SOLO DEVELOPER VER EL CARNET EN UNA PESTAÑA
        // const editedImage = canvas.toDataURL('image/jpeg');
        // const pdfWidth = baseImage.width;
        // const pdfHeight = baseImage.height;
        // const doc = new jsPDF({
        //   orientation: pdfWidth > pdfHeight ? 'landscape' : 'portrait',
        //   unit: 'px',
        //   format: [pdfWidth, pdfHeight]
        // });
        // doc.addImage(editedImage, 'JPEG', 0, 0, pdfWidth, pdfHeight);
        // // Obtener el contenido del PDF como un blob
        // const blob = doc.output('blob');
        // // Crear una URL para el blob
        // const   = URL.createObjectURL(blob);
        // // Abrir la URL en una nueva pestaña del navegador
        // window.open(blobUrl, 'noopener,noreferrer);
      }
    };
  }

  drawTextWithLineBreaks(context: CanvasRenderingContext2D, text: string, x: number, y: number, lineHeight: number) {
    const lines = text.split('\n');
    lines.forEach((line, index) => {
      context.fillText(line, x, y + (index * lineHeight));
    });
  }

  disableArrowKeys(event: KeyboardEvent) {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    }
  }

  insertLineBreaks(text: string, maxLineLength: number): string {
    const regex = new RegExp(`(.{1,${maxLineLength}})`, 'g');
    return text.match(regex)?.join('\n') || text;
  }

  deleteSpaceAsesor(identification: string): string {
    const parts = identification.split('.');
    return parts.length > 1 ? parts[1].trim() : '';
  }  

  get getControl(): { [key: string]: AbstractControl } {
    return this.frmCarnet.controls;
  }

  private getCurrentTimestamp(): string {
  const fecha = new Date();
  const yyyy = fecha.getFullYear();
  const MM = (fecha.getMonth() + 1).toString().padStart(2, '0');
  const dd = fecha.getDate().toString().padStart(2, '0');
  const HH = fecha.getHours().toString().padStart(2, '0');
  const mm = fecha.getMinutes().toString().padStart(2, '0');
  const ss = fecha.getSeconds().toString().padStart(2, '0');
  return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
  }
}